import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-floating-footer',
  templateUrl: './floating-footer.component.html',
  styleUrls: ['./floating-footer.component.scss']
})
export class FloatingFooterComponent implements OnInit {

  @Input() doubleButton = false;

  @Input() displayError: boolean;
  @Input() errorMessageKey: string;

  @Input() leftLabelKey: string;
  @Input() leftButtonDisabled: boolean;
  @Input() leftButtonHidden: boolean;
  @Output() leftButtonAction = new EventEmitter<any>();

  @Input() rightLabelKey: string;
  @Input() rightButtonDisabled: boolean;
  @Input() rightButtonHidden: boolean;
  @Output() rightButtonAction = new EventEmitter<any>();

  constructor() {
  }

  ngOnInit(): void {
  }

  handleLeftButtonActionEvent($event) {
    this.leftButtonAction.emit($event);
  }

  handleRightButtonActionEvent($event) {
    this.rightButtonAction.emit($event);
  }

}
